import { render, staticRenderFns } from "./HomeOrderReports.vue?vue&type=template&id=2e4b92c6&scoped=true"
import script from "./HomeOrderReports.vue?vue&type=script&lang=js"
export * from "./HomeOrderReports.vue?vue&type=script&lang=js"
import style0 from "./HomeOrderReports.vue?vue&type=style&index=0&id=2e4b92c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b92c6",
  null
  
)

export default component.exports